exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-button[data-v-22aec525]{color:#fff!important;line-height:1.45!important;font-weight:700!important;font-size:19px!important;text-transform:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;height:70px;width:90%;background-color:#00ba57!important;text-align:center;padding:0 30px!important;border-radius:100px;border:1px solid transparent}.preview-title h1[data-v-22aec525]{padding:27px 0}.preview-title p[data-v-22aec525]{font-size:20px;padding:5px 0}@media screen and (max-width:650px){.preview-title h1[data-v-22aec525]{font-size:32px}.preview-title p[data-v-22aec525]{font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22aec525","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/mortgage/MortgagePreviewForm.vue
// module id = LLq9
// module chunks = 0